/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        template = require("connection-templates/chatTab/chatContactsProfilesList.tmpl"),
        ChatContactProfileView = require("connection-views/chatTab/ChatContactProfileView"),
        ChatContactsNoProfiles = require("connection-views/chatTab/ChatContactsNoProfiles"),
        ChatContactsProfilesListView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatContactsProfilesListView = Marionette.CompositeView.extend({
            template: template,
            className: "contacts-list-wrapper",
            itemViewContainer: ".contacts-profiles-list-container",
            itemView: ChatContactProfileView,
            emptyView: ChatContactsNoProfiles,

            initialize: function (options) {

                this._title = options.title;

                this._hideOnAllOffline = options.hideOnAllOffline;
                this._contactType = options.contactType;

                this._bindEvents();
            },

            customTemplateHelpers: function () {
                return {
                    title: LE.translator.translate(this._title)
                };
            },

            itemViewOptions: function () {
                return {
                    contactType: this._contactType,
                    hideOnAllOffline: this._hideOnAllOffline
                };
            },

            onRender: function () {
                this._onAvailabilityChange(); //check if there's a need to show this view or if all contacts are offline and configured to hide if all contacts are offline
            },

            onCompositeCollectionRendered: function () {
                this._onAvailabilityChange(); //check if there's a need to show this view or if all contacts are offline and configured to hide if all contacts are offline
            },

            _bindEvents: function () {
                this.listenTo(this, "itemview:chat:contact:clicked", this._onSubViewContactClick);
                this.listenTo(this, "itemview:availability:change", this._onAvailabilityChange);
            },

            _onAvailabilityChange: function () {

                if (this._hideOnAllOffline) {
                    var notOfflineCount = 0;

                    this.collection.each(function (m) {
                        if(this._contactType === CP_CONST.CONTACT_TYPE.USER && m.isUser()){
                            var avail = m.getAvailability();
                            if(!!avail && m.has("contextId")){
                                notOfflineCount += 1;
                            }
                        }
                    }, this);

                    if(this._contactType === CP_CONST.CONTACT_TYPE.USER){
                        this.$el.toggleClass("hide", (notOfflineCount === 0)); //hide the view if there all contacts are offline
                    }

                }
            },

            _onSubViewContactClick: function (view, model, collection) {
                this.trigger("chat:contact:profile:click", model);
            }
        });
    });

    return ChatContactsProfilesListView;
});
